import { api } from '@api/api';
import { Option } from '@api/types/option';

const solutionTypeApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSolutionTypeOptions: build.query<Option[], void>({
      query: () => ({
        url: 'solutionType/options',
      }),
    }),
  }),
});

export const { useGetSolutionTypeOptionsQuery } = solutionTypeApi;
